import { useEffect, useState } from "react";

import { NavLink, useParams } from "react-router-dom";
import { ItsItem, MailGo } from "../../axios";
import { Container } from "react-bootstrap";
import SliderP1 from "../../modules/slider";
import DateInp from "../../modules/dateInp";
import moment from "moment";

import "./css/style.css";
import MapElem from "../../modules/map";

export default function CartPage() {
    const [item, setitem] = useState(null);
    const [load, setLoad] = useState(false);
    const [formGo, setFormGo] = useState(false);
    const [dates, setDates] = useState({
        startDate: moment(), // Инициализируем как объект moment
        endDate: moment().clone().add(1, "days"), // Инициализируем как объект moment
    });
    let loc = window.location;
    let sesion = window.localStorage;
    const [formData, setFormData] = useState({
        tel: "",
        adres: "",
        count: "",
        date_start: dates.startDate ? dates.startDate.format("DD.MM.YYYY") : "",
        date_end: dates.endDate ? dates.endDate.format("DD.MM.YYYY") : "",
    });

    const params = useParams();

    const handleLoadElement = async () => {
        const rezult = await ItsItem({ id: params.id });

        if (rezult.success) {
            setitem(rezult.element);

            setLoad(true);
        } else {
            setLoad(false);
        }
    };
    //   обработка событий ввода и фиксирование их состояния
    const handleChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
            adres: item.title,
            date_start: dates.startDate ? dates.startDate.format("DD.MM.YYYY") : "",
            date_end: dates.endDate ? dates.endDate.format("DD.MM.YYYY") : "",
        });
    };

    // Обработчик отправки формы
    const handleSubmit = async (e) => {
        const form = e.currentTarget;

        if (form.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
        } else {
            e.preventDefault();

            if (loc.search != "") {
                formData.utm = JSON.stringify(queryStringToObject(loc.search));
            }else if (window.localStorage.getItem('utm')){
                formData.utm=window.localStorage.getItem('utm');
            }
            if (sesion) {
                let ses = getYmSessionData(sesion);
                formData.utm_sesion = JSON.stringify(ses);
            }
            if (window.yaCounter97811914) {
                window.yaCounter97811914.reachGoal("clickAddFavorite");
            }
            const isLoggedIn = await MailGo({
                data: formData,
            });

            if (isLoggedIn) {
                // Выполните действия, если вход успешен

                setFormGo(true);
                setTimeout(() => {
                    setFormGo(false);
                }, 2000);
            } else {
                // Выполните действия, если вход неуспешен
            }
        }
    };
    useEffect(() => {
        if (item != null) {
            // Обновляем существующие метатеги
            const metaDescription = document.querySelector('meta[name="description"]');
            const metaOGTitle = document.querySelector('meta[property="og:title"]');
            const metaOGDescription = document.querySelector('meta[property="og:description"]');
            const metaOGUrl = document.querySelector('meta[property="og:url"]');
            const metaOGIMG = document.querySelector('meta[property="og:image"]');

            if (metaDescription) metaDescription.content = item.description;
            if (metaOGTitle) metaOGTitle.content = " " + item.title + " - Аренда73";
            if (metaOGDescription) metaOGDescription.content = item.description;
            if (metaOGUrl) metaOGUrl.content = url;
            if (metaOGIMG) metaOGIMG.content = `https://73kvartir.ru/img/product/${item.img}`;

            // Обновляем заголовок страницы
            document.title = " " + item.title + " - Аренда73";
        }
    }, [item]);
    useEffect(() => {
        if (!load) {
            handleLoadElement();
        }
    }, []);
    useEffect(() => {}, [load]);

    if (!load) {
        return;
    }
    const url = window.location.href;
    /*МАСКА ДЛЯ НОМЕРА ТЕЛЕФОНА*/
    const getInputNumbersValue = function (input) {
        return input.value.replace(/\D/g, "");
    };
    const onPhonePaste = function (e) {
        let input = e.target,
            inputNumbersValue = getInputNumbersValue(input);
        let pasted = e.clipboardData || window.clipboardData;
        if (pasted) {
            let pastedText = pasted.getData("Text");

            if (/\D/g.test(pastedText)) {
                // Attempt to paste non-numeric symbol — remove all non-numeric symbols,
                // formatting will be in onPhoneInput handler
                input.value = inputNumbersValue;
                return;
            }
        }
    };
    const onPhoneKeyDown = function (e) {
        // Clear input after remove last symbol
        console.log("onPhoneKeyDown", e.keyCode);

        let inputValue = e.target.value.replace(/\D/g, "");
        if (e.keyCode === 8 && inputValue.length === 1) {
            e.target.value = "";
        }
    };
    const onPhoneInput = function (e) {
        let input = e.target,
            inputNumbersValue = getInputNumbersValue(input),
            selectionStart = input.selectionStart,
            formattedInputValue = "";

        if (!inputNumbersValue) {
            return (input.value = "");
        }

        if (input.value.length !== selectionStart) {
            // Editing in the middle of input, not last symbol
            if (e.data && /\D/g.test(e.data)) {
                // Attempt to input non-numeric symbol
                input.value = inputNumbersValue;
            }
            return;
        }

        if (["7", "8", "9"].indexOf(inputNumbersValue[0]) > -1) {
            if (inputNumbersValue[0] == "9") inputNumbersValue = "7" + inputNumbersValue;
            let firstSymbols = inputNumbersValue[0] == "8" ? "8" : "+7";
            formattedInputValue = input.value = firstSymbols + " ";
            if (inputNumbersValue.length > 1) {
                formattedInputValue += "(" + inputNumbersValue.substring(1, 4);
            }
            if (inputNumbersValue.length >= 5) {
                formattedInputValue += ") " + inputNumbersValue.substring(4, 7);
            }
            if (inputNumbersValue.length >= 8) {
                formattedInputValue += "-" + inputNumbersValue.substring(7, 9);
            }
            if (inputNumbersValue.length >= 10) {
                formattedInputValue += "-" + inputNumbersValue.substring(9, 11);
            }
        } else {
            formattedInputValue = "+" + inputNumbersValue.substring(0, 16);
        }
        input.value = formattedInputValue;
    };
    return (
        <>
            <div className="breadCrumbs">
                <Container>
                    <a href="/">
                        <img src="/logo_hom.png" alt="" />
                        Квартиры
                    </a>

                    <a className="active">{item.title}</a>
                </Container>
            </div>

            <section className="cartPage">
                <Container>
                    <div className="slider">
                        <SliderP1 imgArr={item.gallary} count={3} />
                    </div>
                    <div className="info">
                        <div className="info_text">
                            <h1>{item.title}</h1>
                            <span className="info">{item.description}</span>
                            <span className="size">Количество комнат: {item.rooms}</span>
                            <span style={{ marginTop: "-8px" }} className="size">
                                Общая площадь: {item.square}
                            </span>
                        </div>

                        <form id="bron" action="" className="form" onSubmit={handleSubmit} onChange={handleChange}>
                            {formGo ? (
                                <div className="otvet"> Ваша заявка успешно отправлена </div>
                            ) : (
                                <div className="form_content">
                                    <div className="upper-form-container">
                                        <div>
                                            <DateInp dates={dates} setDates={setDates} />
                                        </div>
                                        <div>
                                            <div className="form-custom-element in-ppl">
                                                <div className="form-custom-ico ppl">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                                        <path d="M5.49 8.6a.52.52 0 0 0-.3-.1c-.97 0-1.8.71-1.93 1.67l-.43 2.54A2 2 0 0 0 4.82 15h6.36a2 2 0 0 0 1.99-2.3l-.43-2.53a1.95 1.95 0 0 0-1.93-1.67.52.52 0 0 0-.3.1A4.35 4.35 0 0 1 8 9.38a4.35 4.35 0 0 1-2.51-.78zm6.01-4.1a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z"></path>
                                                    </svg>
                                                </div>
                                                <input type="number" id="ppl" min="1" max="4" maxLength={1} autocomplete="off" name="count" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="calc">
                                        <span>Итого за сутки</span>
                                        <b>
                                            <span>{item.price}</span>
                                        </b>
                                    </div>
                                    <label htmlFor="aboutForm">Ваш телефон для бронирования</label>
                                    <div className="form-custom-element in-city">
                                        {/* <InputMask
                                            mask="+7 (___) ___-__-__"
                                            placeholder="Телефон*"
                                            name="tel"
                                            required
                                            className="inp_t t16"
                                            replacement={{
                                                _: /\d/,
                                            }}
                                        /> */}
                                        <input
                                            onInput={onPhoneInput}
                                            onKeyDown={onPhoneKeyDown}
                                            onPaste={onPhonePaste}
                                            required
                                            class="inp_t t16"
                                            data-tel-input
                                            id="phoneInput"
                                            name="tel"
                                            type="tel"
                                            placeholder="+7 (___) ___-__-__"
                                            maxlength="18"
                                        />
                                    </div>
                                    <input type="hidden" id="name" name="adres" value={item.title} />
                                    <button type="submit" className="button">
                                        Забронировать
                                    </button>
                                </div>
                            )}
                        </form>
                    </div>
                </Container>
                <Container className="map_container">
                    <MapElem coor={item.coordinates} title={item.title} />
                </Container>
            </section>
        </>
    );
}
export function queryStringToObject(queryString) {
    // Удаляем начальный символ "?" (если он есть)
    if (queryString.startsWith("?")) {
        queryString = queryString.slice(1);
    }

    // Разделяем строку на пары ключ-значение
    const pairs = queryString.split("&");

    // Создаем объект для хранения результатов
    const result = {};

    // Обрабатываем каждую пару
    pairs.forEach((pair) => {
        // Разделяем ключ и значение
        const [key, value] = pair.split("=").map(decodeURIComponent);

        // Добавляем в объект
        if (key) {
            result[key] = value !== undefined ? value : null; // Если значение отсутствует, устанавливаем null
        }
    });

    return result;
}

function getYmSessionData(sessionObj) {
    const result = {};

    for (const key in sessionObj) {
        if (sessionObj.hasOwnProperty(key) && key.startsWith("_ym")) {
            result[key] = sessionObj[key]; // Добавляем ключ и значение в результирующий объект
        }
    }

    return result;
}
